<!-- https://loading.io/css/ -->
<div class="inline-block relative size-20 *:absolute *:size-16 *:m-2 *:border-8 *:border-t-dusk *:border-x-transparent *:border-b-transparent *:rounded-[50%]"><div class="animate-ring" style="animation-delay: -0.45s;"></div><div class="animate-ring" style="animation-delay: -0.3s;"></div><div class="animate-ring" style="animation-delay: -0.15s;"></div><div class="animate-ring"></div></div>
<style>
.animate-ring {
  animation: ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}
@keyframes ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>